import React, { useState, useEffect } from 'react';
import Paper from '@mui/material/Paper';
import * as XLSX from 'xlsx';
import { fetchData, updateData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import {
    Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, TablePagination, TableFooter
} from '@mui/material';
import { Link } from 'react-router-dom';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import ReportShell, { RC, dateInp, refreshBtn, excelBtn } from './ReportShell';

function SaleRegister() {

    const [dataBill, setDataBill] = useState([]);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [isFocused, setIsFocused] = useState(false);

    const { isAuthenticated, companyId, branchId, permissions, token, username, logout } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        fetchTableData();
        //fetchCustomerData();
    }, [isAuthenticated, companyId, token, branchId, logout]);

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };

    //FOR CHILD 
    const [ChildOptions, setchildOptions] = useState([]);
    const [selectedChildOption, setSelectedChildOption] = useState(null);

    const handleChildInputChange = (newValue) => newValue;

    // Handle customer selection
    const handleChildSelect = (selectedChildOption) => {
        setSelectedChildOption(selectedChildOption);

    };

    const fetchTableData = async () => {
        const itemid = 0;
        setDataItem([])
        try {
            // const response = await fetchData('ReportApi', `/SaleRegister/${companyId}/${itemid}//${fromDate}/${toDate}`, token);
            const response = await fetchData('ReportApi', `/SaleRegister/${fromDate}/${toDate}/${companyId}`, token);
            if (response.responseCode === '1111') {
                setDataItem(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Customer Details:', error);
        }

    };

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setFromDate(selectedDate);
    };

    // Similar function for toDate
    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setToDate(selectedDate);
    };

    const hasReadReportPermission = permissions.includes('Read Reports');

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataBill = dataBill.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    const handleExportExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sale Register Details');

    worksheet.views = [{ state: 'frozen', ySplit: 2 }];

    const now = new Date();
    const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;
    const thinBorder = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
    };

    // 🔹 REPORT HEADER
    worksheet.mergeCells('A1:S1');
    const headerCell = worksheet.getCell('A1');
    headerCell.value = `Sale Data From: ${formatDate(fromDate)} To: ${formatDate(toDate)}  | Generated On: ${formattedDateTime} By: ${username}`;
    headerCell.font = { bold: true, size: 10 };
    headerCell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };

    worksheet.addRow([]);

    // 🔹 COLUMN HEADERS
    const headerTitles = [
        'Bill Date', 'Bill No', 'Name', 'GST No',
        'S 0', 'S 3%', 'GST 3%', 'S 5%', 'GST 5%',
        'S 12%', 'GST 12%', 'S 18%', 'GST 18%',
        'S 28%', 'GST 28%', 'Packing', 'Pack.GST',
        'Round', 'Total'
    ];

    const headerRow = worksheet.addRow(headerTitles);
    headerRow.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: '000000' } };
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFD9EAD3' }, // Light green
        };
        cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
        cell.border = thinBorder;
    });

 // 🔹 DATA ROWS
filteredDataItem.forEach((rowData) => {
    const dataRow = [
        formatDate(rowData.BillDate),
        rowData.BillNumber,
        rowData.MasterName,
        rowData.GSTNumber,
        rowData.Taxable0,
        rowData.Taxable3,
        rowData.GST3,
        rowData.Taxable5,
        rowData.GST5,
        rowData.Taxable12,
        rowData.GST12,
        rowData.Taxable18,
        rowData.GST18,
        rowData.Taxable28,
        rowData.GST28,
        rowData.PackingAmount,
        rowData.PackingGST,
        rowData.RoundOff,
        rowData.TotalAmount
    ];

    const row = worksheet.addRow(dataRow);

    // Style each cell normally
    row.eachCell((cell, colNumber) => {
        cell.border = thinBorder;
        if (colNumber >= 5) {
            cell.alignment = { horizontal: 'right', vertical: 'middle' };
            cell.numFmt = '#,##0.00';
        } else {
            cell.alignment = { horizontal: 'left', vertical: 'middle' };
        }
    });

    // ✅ Highlight rows that contain "Total"
    if (
        String(rowData.MasterName)?.toLowerCase().includes('total') ||
        String(rowData.BillNumber)?.toLowerCase().includes('total')
    ) {
        row.eachCell((cell) => {
            cell.font = { bold: true };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFF4CCCC' }, // 🔸 light pink
            };
        });
    }
});

    // 🔹 ADJUST COLUMN WIDTHS
    worksheet.columns = [
        { width: 15 }, { width: 12 }, { width: 25 }, { width: 15 },
        { width: 10 }, { width: 10 }, { width: 10 }, { width: 10 },
        { width: 10 }, { width: 10 }, { width: 10 }, { width: 10 },
        { width: 10 }, { width: 10 }, { width: 10 }, { width: 12 },
        { width: 12 }, { width: 10 }, { width: 15 }
    ];

    // 🔹 SAVE FILE
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(
        new Blob([buffer]),
        `SaleRegister_From_${formatDate(fromDate).replace(/\//g, '-')}_To_${formatDate(toDate).replace(/\//g, '-')}.xlsx`
    );
};


    const [page, setPage] = useState(0); // Current page
    const [rowsPerPage, setRowsPerPage] = useState(15); // Rows per page

    // Define initial column order
    const [columnOrder, setColumnOrder] = useState([
        'Bill Date',
        'Bill No',
        'Name',
        'GST No',
        'S 0',
        'S 3%',
        'GST 3%',
        'S 5%',
        'GST 5%',
        'S 12%',
        'GST 12%',
        'S 18%',
        'GST 18%',
        'S 28%',
        'GST 28%',
        'Packing',
        'Pack.GST',
        'Freight',
        'Freight.GST',
        'Round',
        'Total',
    ]);

    // Handle page change
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    // Handle rows per page change
    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Reset to the first page
    };

    // Function to handle drag start
    const handleDragStart = (e, index) => {
        e.dataTransfer.setData('columnIndex', index);
    };

    // Function to handle drag over
    const handleDragOver = (e) => {
        e.preventDefault(); // Allow drop
    };

    // Function to handle drop
    const handleDrop = (e, index) => {
        const draggedIndex = e.dataTransfer.getData('columnIndex');
        if (draggedIndex !== index) {
            const newOrder = [...columnOrder];
            // Swap columns
            [newOrder[draggedIndex], newOrder[index]] = [newOrder[index], newOrder[draggedIndex]];
            setColumnOrder(newOrder);
        }
    };

    const grandTotal = filteredDataItem
        .filter((rowData) => rowData.MasterName === "Total")
        .reduce(
            (totals, rowData) => ({
                Taxable0: parseFloat((totals.Taxable0 + (parseFloat(rowData.Taxable0) || 0)).toFixed(2)),
                Taxable3: parseFloat((totals.Taxable3 + (parseFloat(rowData.Taxable3) || 0)).toFixed(2)),
                GST3: parseFloat((totals.GST3 + (parseFloat(rowData.GST3) || 0)).toFixed(2)),
                Taxable5: parseFloat((totals.Taxable5 + (parseFloat(rowData.Taxable5) || 0)).toFixed(2)),
                GST5: parseFloat((totals.GST5 + (parseFloat(rowData.GST5) || 0)).toFixed(2)),
                Taxable12: parseFloat((totals.Taxable12 + (parseFloat(rowData.Taxable12) || 0)).toFixed(2)),
                GST12: parseFloat((totals.GST12 + (parseFloat(rowData.GST12) || 0)).toFixed(2)),
                Taxable18: parseFloat((totals.Taxable18 + (parseFloat(rowData.Taxable18) || 0)).toFixed(2)),
                GST18: parseFloat((totals.GST18 + (parseFloat(rowData.GST18) || 0)).toFixed(2)),
                Taxable28: parseFloat((totals.Taxable28 + (parseFloat(rowData.Taxable28) || 0)).toFixed(2)),
                GST28: parseFloat((totals.GST28 + (parseFloat(rowData.GST28) || 0)).toFixed(2)),
                PackingAmount: parseFloat((totals.PackingAmount + (parseFloat(rowData.PackingAmount) || 0)).toFixed(2)),
                PackingGST: parseFloat((totals.PackingGST + (parseFloat(rowData.PackingGST) || 0)).toFixed(2)),
                FreightAmount: parseFloat((totals.FreightAmount + (parseFloat(rowData.FreightAmount) || 0)).toFixed(2)),
                FreightGSTAmount: parseFloat((totals.FreightGSTAmount + (parseFloat(rowData.FreightGSTAmount) || 0)).toFixed(2)),
                RoundOff: parseFloat((totals.RoundOff + (parseFloat(rowData.RoundOff) || 0)).toFixed(2)),
                TotalAmount: parseFloat((totals.TotalAmount + (parseFloat(rowData.TotalAmount) || 0)).toFixed(2))
            }),
            {
                Taxable0: 0,
                Taxable3: 0,
                GST3: 0,
                Taxable5: 0,
                GST5: 0,
                Taxable12: 0,
                GST12: 0,
                Taxable18: 0,
                GST18: 0,
                Taxable28: 0,
                GST28: 0,
                PackingAmount: 0,
                PackingGST: 0,
                FreightAmount: 0,
                FreightGSTAmount: 0,
                RoundOff: 0,
                TotalAmount: 0
            }
        );

    console.log(grandTotal);

    // Process and paginate the data
    const processedData = filteredDataItem.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );

    return (
        <ReportShell
            title="SALE REGISTER"
            recordCount={filteredDataItem.length}
            filters={<>
                <span style={{ fontSize: '10px', color: RC.muted, marginRight: '4px' }}>From</span>
                <input type="date" value={fromDate} onChange={handleFromDateChange} style={{ ...dateInp, width: '130px' }} />
                <span style={{ fontSize: '10px', color: RC.muted, marginRight: '4px', marginLeft: '8px' }}>To</span>
                <input type="date" value={toDate} onChange={handleToDateChange} style={{ ...dateInp, width: '130px' }} />
            </>}
            actions={<>
                <button onClick={fetchTableData} style={refreshBtn}>Refresh</button>
                <button onClick={handleExportExcel} style={excelBtn}>Excel</button>
            </>}
        >
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {columnOrder.map((col, index) => {
                                    const amountColumns = [
                                        "S 0", "S 3%", "GST 3%", "S 5%", "GST 5%", "S 12%", "GST 12%",
                                        "S 18%", "GST 18%", "S 28%", "GST 28%", "Packing", "Pack.GST",
                                        "Freight", "Freight.GST", "TCS", "Round", "Total"
                                    ];

                                    return (
                                        <TableCell
                                            key={index}
                                            style={{
                                                background: "#e9ecef",
                                                fontWeight: "bold",
                                                fontSize: "11px",
                                                padding: "3px",
                                                borderBottom: "2px solid #ccc",
                                                textTransform: "uppercase",
                                                textAlign: amountColumns.includes(col) ? "right" : "left",
                                            }}
                                        >
                                            {col}
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {processedData
                                .filter(rowData => rowData.MasterName !== "Total") // Exclude "GrandTotal" for the main rows
                                .map((rowData, index) => {
                                    // Map the rowData to columns based on the column order
                                    const rowValues = {
                                        'Bill Date': rowData.BillDate ? formatDate(rowData.BillDate) : '',
                                        // 'Bill No': rowData.BillNumber || '',
                                        'Bill No': (
                                            <a
                                                href={`/SaleDetails/${rowData.Saleid}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ color: 'brown', textDecoration: 'none', fontWeight: 'bolder' }}
                                            >
                                                {rowData.BillNumber}
                                            </a>
                                        ),
                                        Name: rowData.MasterName || '',
                                        'GST No': rowData.GSTNumber || '',
                                        'S 0': rowData.Taxable0 ? parseFloat(rowData.Taxable0).toFixed(2) : '0.00',
                                        'S 3%': rowData.Taxable3 ? parseFloat(rowData.Taxable3).toFixed(2) : '0.00',
                                        'GST 3%': rowData.GST3 ? parseFloat(rowData.GST3).toFixed(2) : '0.00',
                                        'S 5%': rowData.Taxable5 ? parseFloat(rowData.Taxable5).toFixed(2) : '0.00',
                                        'GST 5%': rowData.GST5 ? parseFloat(rowData.GST5).toFixed(2) : '0.00',
                                        'S 12%': rowData.Taxable12 ? parseFloat(rowData.Taxable12).toFixed(2) : '0.00',
                                        'GST 12%': rowData.GST12 ? parseFloat(rowData.GST12).toFixed(2) : '0.00',
                                        'S 18%': rowData.Taxable18 ? parseFloat(rowData.Taxable18).toFixed(2) : '0.00',
                                        'GST 18%': rowData.GST18 ? parseFloat(rowData.GST18).toFixed(2) : '0.00',
                                        'S 28%': rowData.Taxable28 ? parseFloat(rowData.Taxable28).toFixed(2) : '0.00',
                                        'GST 28%': rowData.GST28 ? parseFloat(rowData.GST28).toFixed(2) : '0.00',
                                        'Packing': rowData.PackingAmount ? parseFloat(rowData.PackingAmount).toFixed(2) : '0.00',
                                        'Pack.GST': rowData.PackingGST ? parseFloat(rowData.PackingGST).toFixed(2) : '0.00',
                                        'Freight': rowData.FreightAmount ? parseFloat(rowData.FreightAmount).toFixed(2) : '0.00',
                                        'Freight.GST': rowData.FreightGSTAmount ? parseFloat(rowData.FreightGSTAmount).toFixed(2) : '0.00',
                                        'Round': rowData.RoundOff ? parseFloat(rowData.RoundOff).toFixed(2) : '0.00',
                                        'Total': rowData.TotalAmount ? parseFloat(rowData.TotalAmount).toFixed(2) : '0.00',
                                    };

                                    const amountColumns = [
                                        "S 0", "S 3%", "GST 3%", "S 5%", "GST 5%", "S 12%", "GST 12%",
                                        "S 18%", "GST 18%", "S 28%", "GST 28%", "Packing", "Pack.GST",
                                        "Freight", "Freight.GST", "TCS", "Round", "Total"
                                    ];

                                    return (
                                        <TableRow
                                            key={rowData.Id || index}
                                            sx={{
                                                backgroundColor:
                                                    rowData.MasterName === "Master" ? '#D3F1DF' : 'transparent',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            {columnOrder.map((col, idx) => (
                                                <TableCell
                                                    key={idx}
                                                    sx={{
                                                        padding: "6px",
                                                        fontSize: "12px",
                                                        borderBottom: "1px solid #e0e0e0",
                                                        textAlign: amountColumns.includes(col) ? "right" : "left",
                                                    }}
                                                >
                                                    {rowValues[col]}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    );
                                })}
                        </TableBody>

                        <TableRow
                            key="Total"
                            sx={{ backgroundColor: '#F3F3F3', fontWeight: 'bold' }}
                        >
                            {columnOrder.map((col, idx) => {
                                let cellStyle = {};
                                let cellValue = '';

                                if (col === 'S 0') {
                                    //  cellValue = grandTotal.Taxable0;
                                    cellValue = grandTotal.Taxable0 != null
                                        ? Number(grandTotal.Taxable0).toFixed(2)
                                        : "";
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                } else if (col === 'S 3%') {
                                    //  cellValue = grandTotal.Taxable3;
                                    cellValue = grandTotal.Taxable3 != null
                                        ? Number(grandTotal.Taxable3).toFixed(2)
                                        : "";
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                } else if (col === 'GST 3%') {
                                    //cellValue = grandTotal.GST3;
                                    cellValue = grandTotal.GST3 != null
                                        ? Number(grandTotal.GST3).toFixed(2)
                                        : "";
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                } else if (col === 'S 5%') {
                                    //  cellValue = grandTotal.Taxable5;
                                    cellValue = grandTotal.Taxable5 != null
                                        ? Number(grandTotal.Taxable5).toFixed(2)
                                        : "";
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                } else if (col === 'GST 5%') {
                                    //  cellValue = grandTotal.GST5;
                                    cellValue = grandTotal.GST5 != null
                                        ? Number(grandTotal.GST5).toFixed(2)
                                        : "";
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                } else if (col === 'S 12%') {
                                    // cellValue = grandTotal.Taxable12;
                                    cellValue = grandTotal.Taxable12 != null
                                        ? Number(grandTotal.Taxable12).toFixed(2)
                                        : "";
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                }
                                else if (col === 'GST 12%') {
                                    //cellValue = grandTotal.GST12;
                                    cellValue = grandTotal.GST12 != null
                                        ? Number(grandTotal.GST12).toFixed(2)
                                        : "";
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                }
                                else if (col === 'S 18%') {
                                    // cellValue = grandTotal.Taxable18;
                                    cellValue = grandTotal.Taxable18 != null
                                        ? Number(grandTotal.Taxable18).toFixed(2)
                                        : "";
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                }
                                else if (col === 'GST 18%') {
                                    //cellValue = grandTotal.GST18;
                                    cellValue = grandTotal.GST18 != null
                                        ? Number(grandTotal.GST18).toFixed(2)
                                        : "";
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                }
                                else if (col === 'S 28%') {
                                    //cellValue = grandTotal.Taxable28;
                                    cellValue = grandTotal.Taxable28 != null
                                        ? Number(grandTotal.Taxable28).toFixed(2)
                                        : "";
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                }
                                else if (col === 'GST 28%') {
                                    // cellValue = grandTotal.GST28;
                                    cellValue = grandTotal.GST28 != null
                                        ? Number(grandTotal.GST28).toFixed(2)
                                        : "";
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                }
                                else if (col === 'Packing') {
                                    //  cellValue = grandTotal.PackingAmount;
                                    cellValue = grandTotal.PackingAmount != null
                                        ? Number(grandTotal.PackingAmount).toFixed(2)
                                        : "";
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                }
                                else if (col === 'Pack.GST') {
                                    //cellValue = grandTotal.PackingGST;
                                    cellValue = grandTotal.PackingGST != null
                                        ? Number(grandTotal.PackingGST).toFixed(2)
                                        : "";
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                }
                                else if (col === 'Freight') {
                                    //cellValue = grandTotal.FreightAmount;
                                    cellValue = grandTotal.FreightAmount != null
                                        ? Number(grandTotal.FreightAmount).toFixed(2)
                                        : "";
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                }
                                else if (col === 'Freight.GST') {
                                    //cellValue = grandTotal.FreightGSTAmount;
                                    cellValue = grandTotal.FreightGSTAmount != null
                                        ? Number(grandTotal.FreightGSTAmount).toFixed(2)
                                        : "";
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                }
                                else if (col === 'TCS') {
                                    //cellValue = grandTotal.TCSAmount;
                                    cellValue = grandTotal.TCSAmount != null
                                        ? Number(grandTotal.TCSAmount).toFixed(2)
                                        : "";
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                }
                                else if (col === 'Round') {
                                    //cellValue = grandTotal.RoundOff;
                                    cellValue = grandTotal.RoundOff != null
                                        ? Number(grandTotal.RoundOff).toFixed(2)
                                        : "";
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                }
                                else if (col === 'Total') {
                                    //cellValue = grandTotal.TotalAmount;
                                    cellValue = grandTotal.TotalAmount != null
                                        ? Number(grandTotal.TotalAmount).toFixed(2)
                                        : "";
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                }
                                else if (col === 'Total') {
                                } else if (col === 'Bill Date') {
                                    cellValue = 'Grand Total';
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                }

                                return (
                                    <TableCell key={idx} style={{ padding: '7px', ...cellStyle }}>
                                        {cellValue}
                                    </TableCell>
                                );
                            })}
                        </TableRow>

                        {/* Pagination */}
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[15, 25, 50, 100]}
                                    count={filteredDataItem.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handlePageChange}
                                    onRowsPerPageChange={handleRowsPerPageChange}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </TableContainer>
        </ReportShell>
    );

    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }

    function getComparator(order, orderBy) {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }

    function stableSort(array, comparator) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });
        return stabilizedThis.map((el) => el[0]);
    }

}
export default SaleRegister;